import React, { useEffect, useState } from "react"
import { Layout, Alert, Form, Row, Col, notification, Switch, Modal } from "antd"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

/* CUSTOM COMPONENT */
import { SiteLayoutBackground, Left, Right, LoginBox, XContent, SignIn,StepTitle} from "./SignUpStyle"

/* Actions */
import { sendSignUpRequest , sendSignUpRequestReset} from '../../action/sendSignUpRequestAction'
import DoctorDetail from "../../component/SignUp/DoctorDetail";
import InstituteDetail from "../../component/SignUp/InstituteDetail";
const { Footer } = Layout;
const Signup = props => {
    const {
        sendSignUpRequest,
        sendSignUpRequestState,
    } = props
    const [redirect, setRedirect] = useState([false, ""])
    const [formNumber,setFormNumber] = useState(0)
    const [formData, setFormData] = useState({
        doctorDetails:{},
        instituteDetails:{}
    })

    useEffect(() => {
        
        if(sendSignUpRequestState.apiState == "success")
        {
            notification["success"]({
                message: sendSignUpRequestState.message,
                placement: "topRight"
            })

            setRedirect([true, "/"]) 
        }

        if(sendSignUpRequestState.apiState == "error")
        {   
            notification["error"]({
                message: sendSignUpRequestState.message,
                placement: "topRight"
            }) 
        }
    }, [sendSignUpRequestState])

    const saveData = (key,data) => {
        const temp = {...formData,[key]:data}
        setFormData(temp)
    }
    const handleSubmit = (key,values) => {
        saveData(key,values)
        console.log("Handle Submit")
        const temp = formData
        temp[key] = values
        sendSignUpRequest(temp)
    }


    const displayFormAccordingToNumber = () => {
        switch (formNumber) {
            case 0:
                return <>
                <StepTitle>
                    Doctor Details
                </StepTitle>
                <DoctorDetail handleNext={()=>setFormNumber(1)} saveData={saveData} formData={formData} />
                </>

            case 1:
                return <>
                 <StepTitle>
                    Institute Details
                </StepTitle>
                 <InstituteDetail handlePrevious={()=>setFormNumber(0)} handleSubmit={handleSubmit} formData={formData} saveData={saveData} />
                </>
            default:
                return <h1>{formNumber}</h1>
        }
    }

    return (
            <Layout style={{ backgroundColor: "#fff" }}>
                {redirect[0] &&
                <Redirect to={redirect[1]} />}
                
                {/* <LoginHeader /> */}
                <XContent className="site-layout" style={{ padding: '0 50px', marginTop: 120, }}>
                    <SiteLayoutBackground >
                        <Left>
                            <img height='100%' width='100%' src={process.env.PUBLIC_URL + "/images/svg/DoctorLogin.svg"} alt="" />
                        </Left>
                        <Right>
                            <LoginBox>
                                <SignIn>Sign up</SignIn>
                                {
                                    displayFormAccordingToNumber()
                                }
                            </LoginBox>
                        </Right>
                    </SiteLayoutBackground>
                </XContent>
            </Layout>
    )
}

const mapStateToProps = (state) => ({
    sendSignUpRequestState: state.sendSignUpRequestState
})

const mapDispatchToProps = (dispatch) => ({
    sendSignUpRequest: (params) => dispatch(sendSignUpRequest(params)),
    sendSignUpRequestReset:()=>dispatch(sendSignUpRequestReset())
})

export default connect(mapStateToProps, mapDispatchToProps)(Signup)
